import React from 'react';
import PropTypes from 'prop-types';

export default class MainLayer extends React.Component {
    render() {
        return (
            <div
                id="content-wrapper"
                onClick={this.props.viewer.handleDocumentOnclick}
                onMouseDown={this.props.viewer.handleDocumentMousedown}
                onTouchStart={this.props.viewer.handleDocumentMousedown}
                onContextMenu={this.props.viewer.onContextMenu}
            >
                {this.props.showPrint && (
                    <iframe
                        name="my-frame"
                        id="my-frame"
                        src={this.props.viewer.state.blob}
                        title="my-frame"
                        style={{
                            display: 'none',
                            position: 'absolute',
                            zIndex: 3000,
                            width: '100%',
                            height: '100%',
                        }}
                    />
                )}
                <div id="viewer" ref={el => (this.props.viewer.viewer = el)} className="pdfViewer">
                    {this.props.viewer.state.isInputVisible && this.props.viewer.renderInput()}
                </div>
            </div>
        );
    }
}

MainLayer.propTypes = {
    viewer: PropTypes.object.isRequired,
    showPrint: PropTypes.bool,
};

MainLayer.defaultProps = {
    showPrint: false,
};



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/MainLayer.js